import type { ReactNode } from 'react';

import { AnalyticsProvider } from './AnalyticsProvider';
import { AuthProvider } from './AuthProvider';
import { AppToaster } from './AppToaster';
import { HintProvider } from './HintProvider';
import { QueryProvider } from './QueryProvider';
import { ThemeProvider } from './ThemeProvider';

interface AppProvidersProps {
  children: ReactNode;
}

/**
 * Composes all application providers in the correct order.
 * Order: QueryProvider → ThemeProvider → AnalyticsProvider → AuthProvider → HintProvider
 *
 * `HintProvider` is router-agnostic (no `useLocation`), so it sits here rather
 * than inside the router shell.
 */
export function AppProviders({ children }: AppProvidersProps) {
  return (
    <QueryProvider>
      <ThemeProvider>
        <AnalyticsProvider>
          <AuthProvider>
            <HintProvider>
              {children}
              <AppToaster />
            </HintProvider>
          </AuthProvider>
        </AnalyticsProvider>
      </ThemeProvider>
    </QueryProvider>
  );
}
